import { AUTH_URL } from "../../urls.api";
export const RESET_PASSWORD_URL = `${AUTH_URL}/reset-password`;
